module.exports = __webpack_public_path__ + "static/media/Elkem.c4e1513a.webp";